/* ============================================================
   Oasis lead-capture CTAs
   Handles: the call / WhatsApp chooser, the hero Handbook toggle,
   and email lead-capture form submissions.
   Config is provided by window.OASIS_CTA (set in theme.liquid).
   ============================================================ */
(function () {
  var CFG = window.OASIS_CTA || {};

  /* ---- contact chooser ---------------------------------------------------- */
  var chooser = document.getElementById('oasis-chooser');

  function closeChooser() { if (chooser) chooser.hidden = true; }
  function toggleChooser() { if (chooser) chooser.hidden = !chooser.hidden; }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-oasis-open-chooser]')) {
      e.preventDefault();
      toggleChooser();
      return;
    }
    if (chooser && !chooser.hidden && !e.target.closest('#oasis-chooser')) {
      closeChooser();
    }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeChooser();
  });

  /* ---- hero Handbook toggle ---------------------------------------------- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-oasis-handbook-toggle]');
    if (!toggle) return;
    var wrap = toggle.closest('[data-oasis-handbook]');
    var capture = wrap && wrap.querySelector('[data-oasis-handbook-capture]');
    if (!capture) return;
    var willOpen = capture.hidden;
    capture.hidden = !willOpen;
    toggle.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    if (willOpen) {
      var input = capture.querySelector('input[type=email]');
      if (input) input.focus();
    }
  });

  /* ---- email lead-capture forms ------------------------------------------ */
  function validEmail(v) {
    return /^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v);
  }

  function submitLead(form) {
    var input = form.querySelector('input[type=email]');
    var email = input ? input.value.trim() : '';
    var row = form.querySelector('.oasis-lead-form__row');
    var note = form.querySelector('.oasis-lead-form__note');
    var okMsg = form.querySelector('[data-oasis-lead-success]');
    var errMsg = form.querySelector('[data-oasis-lead-error]');
    var btn = form.querySelector('button[type=submit]');

    if (okMsg) okMsg.hidden = true;
    if (errMsg) errMsg.hidden = true;

    if (!validEmail(email)) { if (errMsg) errMsg.hidden = false; return; }

    var listId = form.getAttribute('data-list-id') || '';
    var source = form.getAttribute('data-source') || 'Oasis CTA';

    /* Build profile properties from data-* attributes; only include set values. */
    var props = { 'Lead Source': source };
    var lotMap = [
      ['data-lot', 'Lot'],
      ['data-lot-url', 'Lot URL'],
      ['data-lot-price', 'Lot Price'],
      ['data-lot-monthly', 'Lot Monthly'],
      ['data-lot-island', 'Lot Island'],
      ['data-lot-proposal-url', 'Lot Proposal URL']
    ];
    for (var i = 0; i < lotMap.length; i++) {
      var v = form.getAttribute(lotMap[i][0]);
      if (v) props[lotMap[i][1]] = v;
    }

    if (btn) btn.disabled = true;

    function finish(success) {
      if (btn) btn.disabled = false;
      if (success) {
        if (row) row.hidden = true;
        if (note) note.hidden = true;
        if (okMsg) okMsg.hidden = false;
      } else if (errMsg) {
        errMsg.hidden = false;
      }
    }

    var payload = { email: email, list_id: listId, properties: props };

    /* Lot info-pack requests also fire a "Requested Info Pack" event so a
       metric-triggered flow can deliver the pack on EVERY request (list
       triggers only fire the first time someone joins the list). */
    if (CFG.klaviyoKey && form.getAttribute('data-lot')) {
      try {
        fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(CFG.klaviyoKey), {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
          body: JSON.stringify({ data: { type: 'event', attributes: {
            properties: props,
            metric: { data: { type: 'metric', attributes: { name: 'Requested Info Pack' } } },
            profile: { data: { type: 'profile', attributes: { email: email } } }
          } } })
        }).catch(function () {});
      } catch (err) {}
    }

    /* Option 1: generic webhook (e.g. a Zapier catch hook). Most robust. */
    if (CFG.webhook) {
      fetch(CFG.webhook, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload)
      }).then(function (r) { finish(r.ok); }).catch(function () { finish(false); });
      return;
    }

    /* Option 2: Klaviyo client-side subscriptions API.
       NOTE: verify the `revision` date and that the list allows client
       subscriptions when QAing on a live store. */
    if (CFG.klaviyoKey && listId) {
      var body = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: source,
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                  properties: props
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: listId } } }
        }
      };
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(CFG.klaviyoKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', revision: '2024-10-15' },
        body: JSON.stringify(body)
      }).then(function (r) { finish(r.status === 202 || r.ok); })
        .catch(function () { finish(false); });
      return;
    }

    /* Not configured yet: show success so the UI can be QA'd; warn in console. */
    console.warn('[Oasis CTA] No webhook or Klaviyo key set; lead not delivered:', payload);
    finish(true);
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('[data-oasis-lead-form]');
    if (!form) return;
    e.preventDefault();
    submitLead(form);
  });
})();
